import { render, staticRenderFns } from "./BlockListVideo.vue?vue&type=template&id=cf8f9a66&"
import script from "./BlockListVideo.vue?vue&type=script&lang=js&"
export * from "./BlockListVideo.vue?vue&type=script&lang=js&"
import style0 from "./BlockListVideo.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports